import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../utils/Hooks";
import { createRecommendationRoute } from "../../../store/reducers/LockedRecommendationsSlice";
import { getCountries } from "../../../store/reducers/CountriesSlice";
import { getServices } from "../../../store/reducers/ServicesSlice";

interface Props {
    open: boolean
    onClose: () => void
    onSaved: () => void
}

export const NewModal: React.FC<Props> = ({ open, onClose, onSaved }) => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getCountries());
        dispatch(getServices({} as any));
    }, [dispatch]);

    const services = useAppSelector(state => state.services.services);
    const countries = useAppSelector(state => state.countries.countries);

    const [serviceId, setServiceId] = useState<number | null>(null);
    const [startCountryId, setStartCountryId] = useState<number | null>(null);
    const [destinationCountryId, setDestinationCountryId] = useState<number | null>(null);
    const [type, setType] = useState<'partial' | 'full'>('partial');
    const [comment, setComment] = useState<string>('');

    useEffect(() => {
        if (!open) return;

        setServiceId(null);
        setStartCountryId(null);
        setDestinationCountryId(null);
        setType('partial');
        setComment('');
    }, [open]);

    if (!open) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
        }}>
            <div
                style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                onClick={onClose}
            />
            <div style={{position: 'relative', zIndex: 1}}>
                <div style={{
                    background: '#fff',
                    padding: '20px',
                    borderRadius: '8px',
                    width: '500px',
                    maxWidth: '90%',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                }}>
                    <h2>Lisa uus marsruut</h2>
                    <div style={{marginTop: '10px'}} />

                    <select
                        value={serviceId ?? ''}
                        onChange={(e) => setServiceId(Number(e.target.value))}
                        style={{width: '100%', marginTop: '10px'}}
                    >
                        <option value="">Vali teenus</option>
                        {services.map((s: any) => (
                            <option key={s.id} value={s.id}>{s.name}</option>
                        ))}
                    </select>

                    <select
                        value={startCountryId ?? ''}
                        onChange={(e) => setStartCountryId(Number(e.target.value))}
                        style={{width: '100%', marginTop: '10px'}}
                    >
                        <option value="">Algusriik</option>
                        {countries.map((c: any) => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                        ))}
                    </select>

                    <select
                        value={destinationCountryId ?? ''}
                        onChange={(e) => setDestinationCountryId(Number(e.target.value))}
                        style={{width: '100%', marginTop: '10px'}}
                    >
                        <option value="">Sihtkoht</option>
                        {countries.map((c: any) => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                        ))}
                    </select>

                    <select
                        value={type}
                        onChange={(e) => setType(e.target.value as any)}
                        style={{width: '100%', marginTop: '10px'}}
                    >
                        <option value="partial">&lt;13.6 ldm</option>
                        <option value="full">13.6 ldm</option>
                    </select>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Kommentaar"
                        style={{width: '100%', minHeight: '120px', marginTop: '10px'}}
                    />

                    <div style={{marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <button style={{padding: '8px 14px', height: '38px', border: '1px solid #ccc', borderRadius: '6px', background: '#fff', cursor: 'pointer'}} onClick={onClose}>
                            Tühista
                        </button>

                        <button
                            style={{padding: '8px 14px', height: '38px', border: '1px solid #1976d2', borderRadius: '6px', background: '#1976d2', color: '#fff', cursor: 'pointer'}}
                            disabled={!serviceId || !startCountryId || !destinationCountryId}
                            onClick={async () => {
                                await dispatch(createRecommendationRoute({
                                    service_id: serviceId,
                                    start_country_id: startCountryId,
                                    destination_country_id: destinationCountryId,
                                    type,
                                    comment
                                }));
                                onSaved();
                            }}
                        >
                            Salvesta
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
